<template>
  <button
    :class="{ disabled }"
    @click.prevent="$emit('click')"
  >
    <slot />
  </button>
</template>
<script>
export default {
  name: 'FormButton',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="postcss" scoped>
button {
  width: 165px;
  font-family: 'univia-pro';
  font-size: 30px;
  @apply bg-blue text-blue-lighter p-1;

  &.disabled {
    @apply text-blue bg-blue-dark pointer-events-none;
  }

  &:focus {
    outline: 0;
  }
}
</style>
